/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiLocationVelocityTypeFromJSON, ApiLocationVelocityTypeToJSON, } from './ApiLocationVelocityType';
import { ApiProjectDefaultFromJSON, ApiProjectDefaultToJSON, } from './ApiProjectDefault';
export function ApiLocationSimplifiedFromJSON(json) {
    return ApiLocationSimplifiedFromJSONTyped(json, false);
}
export function ApiLocationSimplifiedFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'automate': !exists(json, 'automate') ? undefined : json['automate'],
        'clickToInteraction': !exists(json, 'clickToInteraction') ? undefined : json['clickToInteraction'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        '_default': !exists(json, 'default') ? undefined : ApiProjectDefaultFromJSON(json['default']),
        'deletedAt': !exists(json, 'deletedAt') ? undefined : (new Date(json['deletedAt'])),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'onboardingId': !exists(json, 'onboardingId') ? undefined : json['onboardingId'],
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'showInAnalytics': !exists(json, 'showInAnalytics') ? undefined : json['showInAnalytics'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'urlMatch': !exists(json, 'urlMatch') ? undefined : json['urlMatch'],
        'velocityLimit': !exists(json, 'velocityLimit') ? undefined : json['velocityLimit'],
        'velocityRender': !exists(json, 'velocityRender') ? undefined : json['velocityRender'],
        'velocityType': !exists(json, 'velocityType') ? undefined : ApiLocationVelocityTypeFromJSON(json['velocityType']),
    };
}
export function ApiLocationSimplifiedToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'automate': value.automate,
        'clickToInteraction': value.clickToInteraction,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'default': ApiProjectDefaultToJSON(value._default),
        'deletedAt': value.deletedAt === undefined ? undefined : (value.deletedAt.toISOString()),
        'id': value.id,
        'name': value.name,
        'onboardingId': value.onboardingId,
        'projectId': value.projectId,
        'showInAnalytics': value.showInAnalytics,
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'urlMatch': value.urlMatch,
        'velocityLimit': value.velocityLimit,
        'velocityRender': value.velocityRender,
        'velocityType': ApiLocationVelocityTypeToJSON(value.velocityType),
    };
}
